import { IPageAddCallback, api } from "./index";
import { message, Modal } from "antd";
import { lang } from "../context";
import events from "../context/events";
import { ActionFnEnum, ActionType } from "../types";
const { confirm } = Modal;

const remove: IPageAddCallback = (props, isAllow) => {
  const { data, remove, setData } = props;
  return [
    {
      children: lang("common.list-remove"),
      callbackOrModal: () => {
        confirm({
          title: lang("tags.delete-doc-title"),
          content: lang("tags.delete-doc-prompt"),
          okText: lang("common.confirm"),
          cancelText: lang("common.cancel"),
          onOk() {
            remove();
          }
        });
      },
      isAllow,
      type: "delete",
      icon: "pc_yundoc_yichu",
      splitCode: 3
    }
  ];
};

export default remove;
